import * as React from 'react';

const SvgTaxiIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="128.000000pt"
      height="128.000000pt"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" stroke="none" fill="#bd7816">
        <path
          d="M540 1060 c-11 -11 -20 -26 -20 -33 0 -9 -26 -17 -76 -24 -93 -13
-107 -26 -148 -130 l-31 -78 -50 -5 c-40 -4 -52 -10 -64 -32 -21 -36 -2 -76
39 -84 16 -4 30 -7 30 -8 0 0 -7 -23 -15 -50 -11 -34 -15 -95 -15 -203 l0
-155 29 -29 c17 -16 40 -29 54 -29 39 0 74 35 82 80 l7 40 278 0 278 0 7 -36
c8 -45 46 -84 80 -84 16 0 38 12 56 29 l29 29 0 149 c0 136 -5 180 -24 239 -5
18 -2 22 24 27 41 9 60 48 39 85 -12 22 -24 28 -64 32 l-50 5 -31 78 c-40 103
-53 114 -147 129 -49 8 -77 17 -77 25 0 7 -9 22 -20 33 -17 17 -33 20 -100 20
-67 0 -83 -3 -100 -20z m363 -233 c15 -46 27 -86 27 -90 0 -4 -130 -7 -290 -7
-159 0 -290 3 -290 7 0 4 12 44 27 90 l27 83 236 0 236 0 27 -83z m-531 -234
c25 -22 24 -79 -1 -93 -32 -17 -69 -12 -85 12 -21 29 -20 40 5 72 23 30 54 33
81 9z m614 -8 c27 -27 26 -59 -4 -82 -34 -27 -84 -9 -97 34 -7 25 32 73 60 73
9 0 27 -11 41 -25z"
        />
      </g>
    </svg>
  );
};

export default SvgTaxiIcon;
